import { t } from '../../../utils'
import { LabWelcomeGuideStep } from '../../../__generated__/graphql'
import styles from './_onboardProgress.module.scss'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { LabOnboardingContext } from './LabOnboardingProvider'
import { useContext } from 'react'

const HIDE_AFTER_COMPLETE_MS = 48 * 60 * 60 * 1000

const shouldHideAfterComplete = (steps: LabWelcomeGuideStep[]): boolean => {
  if (!steps.length) return false

  const completedTimestamps = steps.map((step) =>
    new Date(step.completedAt).getTime()
  )

  const lastCompletedAt =
    completedTimestamps.length > 0 ? Math.max(...completedTimestamps) : 0

  return (
    lastCompletedAt > 0 && Date.now() - lastCompletedAt > HIDE_AFTER_COMPLETE_MS
  )
}

const OnboardProgress: React.FC = () => {
  const {
    userSteps,
    completedCount,
    totalSteps,
    isComplete,
    loading,
    openWelcomeModal,
    openCongratsModal
  } = useContext(LabOnboardingContext)

  const progressPercent =
    totalSteps > 0 ? (completedCount / totalSteps) * 100 : 0

  if (loading) return null

  if (isComplete && shouldHideAfterComplete(userSteps)) {
    return null
  }

  const handleClick = () => {
    if (isComplete) {
      openCongratsModal()
    } else {
      openWelcomeModal()
    }
  }

  return (
    <div className={styles.wrapper}>
      <div
        className={styles.gradientBorder}
        onClick={handleClick}
        role="button"
      >
        <div className={styles.button}>
          <span className={styles.icon} aria-hidden>
            {isComplete ? '\u{1F389}' : '\u{1F680}'}
          </span>
          <div className={styles.content}>
            {isComplete ? (
              <span className={styles.text}>{t("You're All Set")}</span>
            ) : (
              <>
                <span className={styles.text}>
                  {completedCount} of {totalSteps} {t('Steps Complete')}
                </span>
                <div className={styles.progressTrack}>
                  <div
                    className={styles.progressFill}
                    style={{ width: `${progressPercent}%` }}
                  />
                </div>
              </>
            )}
          </div>
          {!isComplete && (
            <FontAwesomeIcon icon={faChevronRight} color="#fff" />
          )}
        </div>
      </div>
    </div>
  )
}

export default OnboardProgress
